import { Stroke } from './stroke.model';
import { Vertex } from './vertex.model';

export class Polygon {
    public vertices: Vertex[];
    stroke: Stroke;
    constructor() {
        this.vertices = new Array<Vertex>();
    }
}
